import React from 'react';
import { GrFormClose } from 'react-icons/gr';
import '../../styles/infoPage.scss'

const InfoPage = ({setIsInfo}) => {
    return (
        <div className='info_pop-up_wrap'>
            <div className='info_pop-up_content'>
                <div className='pop-up_header'>
                    <h3>Information</h3>
                    <button onClick={() => setIsInfo(state => !state) }><GrFormClose/></button>
                </div>
                <div className='pop-up_body'>
                    <div className='server_wrap_pop-up'>
                        <div className='server_wrap_pop-up_img-bg'>
                            <img className='img_glow' src="/img/popup/Glow.svg" alt="" />
                            <img className='img_sever' src="/img/popup/Server Image.svg" alt="" />
                        </div>
                        <h3>Themis</h3>
                        <p>Discord Security Bot</p>
                    </div>
                    <div className='content_pop-up_text'>
                        <div className='pop-up_text_item'>
                            <div className='pop-up_text_item-header'>
                                <img src="/img/popup/info.svg" alt="Information.svg"/>
                                <h3>Description:</h3>
                            </div>
                            <div className='pop-up_text_item-body'>
                                <p>Alwond Limited designed and developed Themis, a next-generation Discord security bot, to protect against threats inside and outside the server. The bot suppresses any attempt to disrupt the server due to its unique algorithm and time-tested system.</p>
                            </div>
                        </div>
                        <div className='pop-up_text_item'>
                            <div className='pop-up_text_item-header'>
                            <img src="/img/popup/Feature.svg" alt="Information.svg"/>
                                <h3>Features:</h3>
                            </div>
                            <div className='pop-up_text_item-body'>
                                    <li><span>Anti-Webhook: </span>Prevents server members from using webhooks without permission. The algorithm is based on several indicators that indicate the possibility of a malicious webhook being created.</li>
                                    <li><span>Anti-Spam: </span>The bot recognises potentially harmful messages such as repeated messages, Zalgo text, and external links. The bot employs the quarantine method, adding suspicious accounts to a list and immediately punishes them when triggered.</li>
                                    <li><span>Anti-Raid [Beta]: </span>The bot prevents bot raids by employing a flexible, AI-like algorithm that works around the clock to prevent bot raids on your server, automatically mitigating raid threats through mass banning. The algorithm's flexibility and accuracy prevent real users from being blocked. Furthermore, the algorithm is improved regularly by analysing the various exclusive and private software abusers use.</li>
                                    <li><span>Anti-Nuke [Beta]: </span>The bot constantly observes all members and develops a consistent pattern of behaviour. The bot isolates a member if a divergence occurs until the server owner arrives.</li>
                                    <li><span>Fake Detection: </span>Also known as impersonator detection. The algorithm, created in October 2021, has been improved and can now detect fake accounts accurately. Furthermore, the manager can create a personal dictionary of banned nicknames, which the bot will use to ban users with those names. In addition to the personal dictionary, a global dictionary that is constantly updated can be linked.</li>
                                    <li><span>Verification: </span>Bots are prevented from accessing the server by using captcha verification. Themis has two types of captcha - numeric and picture. Furthermore, there are indicators in verification that are triggered by divergent normal user behaviour. </li>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='pop-up_footer'>
                    <div className='pop-up_footer-item'>
                        <img src="/img/popup/discord.svg" alt="" />
                        <p>Discord Server</p>
                    </div>
                    <div className='pop-up_footer-item'>
                        <img src="/img/popup/twiter.svg" alt="" />
                        <p>Twitter</p>
                    </div>
                    <div className='pop-up_footer-item'>
                        <img src="/img/popup/documentation.svg" alt="" />
                        <p>Documentation</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoPage;